import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ExportButton, TopToolbar, useResourceContext } from "react-admin";
import { NestedList } from "$components/NestedList/NestedList";
import { CoinLevelsListData } from "./CoinLevelsListData";
import { exportNestedList } from "$components/List/ListActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
const CoinLevels = (props) => {
    const resourceName = useResourceContext();
    return (_jsx(NestedList, { searchField: "name", subCollection: "CoinLevels", actions: _jsx(TopToolbar, { children: _jsx(ExportButton, {}) }), ...props, resource: "CoinLeaderboards", empty: _jsx(CardContent, { children: _jsx(Typography, { children: "Choose the coin tracker period" }) }), exporter: exportNestedList("CoinLeaderboardsCoinLevels"), children: _jsx(CoinLevelsListData, { model: "CoinLevels", resourceName: resourceName }) }));
};
export { CoinLevels };
